export default __webpack_public_path__ + "static/treneri-libuse-hybsova-4c4d49a3c846a40e7277ebdfc083d149.jpg";